import { render, staticRenderFns } from "./AlertInPage.vue?vue&type=template&id=0abb14ef&"
import script from "./AlertInPage.vue?vue&type=script&lang=js&"
export * from "./AlertInPage.vue?vue&type=script&lang=js&"
import style0 from "./AlertInPage.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports